"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ducktypeStringMap = exports.stringDuckType = void 0;
const basics_1 = require("../../Math/basics");
/** use where strings may be a representation of numbers or booleans, eg UI Observation inputs */
const stringDuckType = (s) => {
    let res = s;
    const typeMap = {
        isNumber: !isNaN(parseFloat(s)),
        isBoolean: ['true', 'false'].includes(s.toLowerCase()),
    };
    const extendedTypeMap = {
        isInteger: typeMap.isNumber && parseInt(s) === parseFloat(s),
        isMSTimestamp: typeMap.isNumber && (0, basics_1.between)(parseInt(s), 1577790000000, 2524561200000),
        isDateTime: !typeMap.isNumber && !isNaN(new Date(s).valueOf()),
    };
    if (extendedTypeMap.isMSTimestamp) {
        res = parseInt(s);
    }
    else if (extendedTypeMap.isDateTime) {
        res = new Date(s).valueOf();
    }
    else if (typeMap.isBoolean) {
        res = s.toLowerCase() === 'true';
    }
    else if (typeMap.isNumber) {
        if (extendedTypeMap.isInteger) {
            res = parseInt(s);
        }
        else {
            res = parseFloat(s);
        }
    }
    return res;
};
exports.stringDuckType = stringDuckType;
const ducktypeStringMap = (ob) => {
    return Object.fromEntries(Object.entries(ob).map(([k, v]) => {
        const cast = [k, v];
        if (v === null) {
            cast[1] = null;
        }
        else if (v instanceof Array) {
            cast[1] = v.map((vi, i) => (0, exports.ducktypeStringMap)(vi));
        }
        else if (typeof v === 'object') {
            cast[1] = (0, exports.ducktypeStringMap)(v);
        }
        else if (typeof v === 'string') {
            cast[1] = (0, exports.stringDuckType)(v);
        }
        return cast;
    }));
};
exports.ducktypeStringMap = ducktypeStringMap;
